export enum NotificationMessageTypeEnum {
    Success = 'success',
    Error = 'danger',
    Warning = 'warning',
    Info = 'info',
}
